// SF 監査ユーザー棚卸し API クライアント。GET /sf/users/active → SfActiveUserDto[]。
// ApiClient に認証・エラー正規化を委譲。backend SfActiveUser に対応する DTO。
import type { ApiClient } from "../api/client";

export interface UserReconcileApiDeps {
  readonly apiClient: ApiClient;
}

export interface SfActiveUserDto {
  readonly id: string;
  readonly username: string;
  readonly email: string;
  readonly name: string;
  readonly profile: string;
  readonly lastLoginDate?: string;
}

interface ActiveUsersResponse {
  readonly users: SfActiveUserDto[];
}

// GET /sf/users/active → SfActiveUserDto[]（SF 組織のアクティブユーザー一覧）
export async function fetchActiveUsers(deps: UserReconcileApiDeps): Promise<SfActiveUserDto[]> {
  const res = await deps.apiClient.get<ActiveUsersResponse>("/sf/users/active");
  return res.users;
}
